import { Component, ElementRef, OnInit, ViewChild, OnDestroy, AfterViewInit, inject, DestroyRef, signal } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { findIana } from 'windows-iana';
import { MatSelectionList, MatSelectionListChange } from '@angular/material/list';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { TranslateService } from '@ngx-translate/core';

import { PopupRequest, RedirectRequest } from '@azure/msal-browser';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { lastValueFrom, Observable, of, timer, forkJoin } from 'rxjs';
import { catchError, debounceTime, filter, first, map, startWith } from 'rxjs/operators';

import { DatabaseService } from '../../servicios/database/database.service';
import { DatosUsuario, LANGS_V2, Municipio, SupportedLanguages } from 'src/app/models';
import { PerfilUsarioComponent } from 'src/app/dialogs/perfil-usario/perfil-usario.component';
import { ConfMunicipioComponent } from 'src/app/dialogs/conf-municipio/conf-municipio.component';
import { FsessionService } from '../../servicios/session/fsession.service';
import { environment } from 'src/environments/environment';
import { InicializadorAppsComponent } from 'src/app/dialogs/inicializador-apps/inicializador-apps.component';
import { ListenDOMChange } from 'src/app/servicios/listen-DOM-change/listen-DOM-change.service';
import { AcercaDeComponent } from 'src/app/dialogs/acerca-de/acerca-de.component';
import { NotificationService } from 'src/app/servicios/notification/notification.service';
import { LoaderService } from '../loader-spinner/loader.service';
import { MessageService } from 'src/app/servicios/message/message.service';
import { UpdateService } from 'src/app/servicios/update/update.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';
import Swal, { SweetAlertResult } from 'sweetalert2';
import { configuracion } from 'src/configuracion';
import { MunicipalityTokenService } from 'src/app/servicios/municipality-token/municipality-token.service';
import { PermissionsService } from 'src/app/servicios/permissions/permissions.service';
import { TokenRefreshService } from 'src/app/servicios/municipality-token/token-refresh.service';
import { updateTokensAndRefresh } from 'src/app/servicios/municipality-token/token-utils';
import { DialogoRutaModoPredeterminadoComponent } from 'src/app/dialogs/ruta-modo-predeterminado/dialogo-ruta-modo-predeterminado.component';
import { ROUTING_MODULE_LOADERS } from 'src/app/servicios/default-route/default-route-navigation.service';

export interface ModeloAlerta {
  IdAlerta: number;
  Origen: String;
  Mesaje: String;
  Contador: String;
  FechaUltimaIncidencia: String;
  FechaAlerta: String;
  IdMunicipio: number;
  Municipio: String;
  Ip: String;
}

export interface MenuHeader {
  type: number;
  routerLink: string;
  name: string;
  permission: string;
  hasAccess?: boolean;
}

export interface SubheaderRoute {
  id_rol: number;
  nombre: string;
  id_ruta: number;
  ruta: string;
  tipo: number;
  fecha_creacion: string;
  activo: boolean;
  lectura_escritura: boolean;
  descripcion?: string;
  hasAccess?: boolean;
}

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy, AfterViewInit {
  private translate = inject(TranslateService);
  fse = inject(FsessionService);
  private db = inject(DatabaseService);
  private dialog = inject(MatDialog);
  private router = inject(Router);
  private msalService = inject(MsalService);
  private msalGuardConfig = inject<MsalGuardConfiguration>(MSAL_GUARD_CONFIG);
  private authService = inject(MsalService);
  private _listenDOMChange = inject(ListenDOMChange);
  private _notificationService = inject(NotificationService);
  private _loaderService = inject(LoaderService);
  private _messageService = inject(MessageService);
  private _updateService = inject(UpdateService);
  private Title = inject(Title);
  private municipalityTokenService = inject(MunicipalityTokenService);
  private permissionsService = inject(PermissionsService);
  private tokenRefreshService = inject(TokenRefreshService);

  @ViewChild('manualUrl', { static: false }) manualAnchor: ElementRef;
  @ViewChild('sidenav') sidenav: MatSidenav;
  @ViewChild(MatSelectionList, { static: false }) matSelectionList: MatSelectionList;

  @ViewChild(AcercaDeComponent, { static: false }) acercaDe: AcercaDeComponent;

  private $destroyRef = inject(DestroyRef);
  nameUser: string;
  language: string;
  mail: string;
  rol: string;
  userRolName = '---';
  userRolNameSig = signal('---');
  ListMun: Municipio[];
  ListDataUSer: DatosUsuario;
  Munselect: Municipio;
  MunselectSaved: Municipio;

  ListAlert: ModeloAlerta[];
  RoutesAvaliable;
  ChildRoutes: any[] = [];
  headerSelect = 1;
  isMobile: boolean;
  enableAdm = new FormControl(false);

  headers: MenuHeader[] = [];

  text = '';
  results = [];
  citySearchControl = new FormControl();
  searchedCity = '';
  showAdmin = false;
  appState: boolean;
  showOrHide: boolean;

  /** Categorías del filtro de municipios (label = clave i18n). */
  municipioFilterCategories: { id: string; label: string; icon: string }[] = [
    { id: 'guardian', label: 'guardian', icon: 'shield' },
    { id: 'fotoRojo', label: 'foto-rojo', icon: 'photo_camera' },
    { id: 'zar', label: 'zar', icon: 'gavel' },
    { id: 'pasoCebra', label: 'paso-cebra', icon: 'directions_walk' },
    { id: 'residuos', label: 'residuos', icon: 'delete' },
  ];
  selectedMunicipioFilterCategory: string | null = null;
  showMunicipioFilters = true;
  /** IDs de municipios con Foto Rojo (vista V_MunicipiosConFotoRojo). */
  municipiosConFotoRojoIds: number[] = [];
  /** IDs de municipios con ZAR (vista V_MunicipiosConZar). */
  municipiosConZarIds: number[] = [];
  /** IDs de municipios con Paso Cebra (vista V_MunicipiosConPasoCebra). */
  municipiosConPasoCebraIds: number[] = [];
  /** IDs de municipios con Residuos (vista V_MunicipiosConResiduos). */
  municipiosConResiduosIds: number[] = [];
  /** IDs de municipios con Guardian (vista V_MunicipiosConGuardian). */
  municipiosConGuardianIds: number[] = [];

  translateKeys = [
    'establecer-como-predeterminado',
    'idioma-se-usara-como-predeterminado',
    'no-guardar',
    'si-usar-predeterminado',
    'mensaje_confirmacion',
    'error_contacto',
    'traducir_mensaje'
  ]
  variables: any;

  isMultipleSelection: boolean = false;
  selectedMunicipios: any[] = [];
  maxMunicipiosSelected = 50;
  showCounterMunicipioVirtual = false;
  municipioUserSlider: boolean;
  showPanelesSubmenu = false;
  selectedPanelPath: string | null = null;

  /**
   * Definición centralizada de módulos de la plataforma.
   * Si se quiere agregar un nuevo módulo, solo hay que declararlo aquí.
   */
  private readonly MODULE_DEFINITIONS: Record<number, {
    /** Identificador numérico del módulo (coincide con headerSelect/urlRouting) */
    type: number;
    /** Segmento de ruta principal, p.ej. 'management' => '/management' */
    routeSegment: string;
    /** Carpeta donde se establece el módulo de rutas, p.ej. 'administrate' */
    moduleFolder: string;
    /** Clave a traducir que se usa como nombre visible en el header y en móvil */
    translationKey: string;
    /** Si se muestra en el header principal (barra superior) */
    showInMainHeader: boolean;
    /** Si se usa como etiqueta en el selector móvil */
    showInMobileSelector: boolean;
  }> = {
    1: { type: 1, routeSegment: 'traffic',    moduleFolder: 'traffic',      translationKey: 'Trafico',      showInMainHeader: true,  showInMobileSelector: true },
    2: { type: 2, routeSegment: 'management', moduleFolder: 'management',   translationKey: 'Gestion',      showInMainHeader: true,  showInMobileSelector: true },
    3: { type: 3, routeSegment: 'admin',      moduleFolder: 'administrate', translationKey: 'Administrar',  showInMainHeader: false, showInMobileSelector: true },
    4: { type: 4, routeSegment: 'telemetry',  moduleFolder: 'telemetry',    translationKey: 'Telemetría',   showInMainHeader: true,  showInMobileSelector: true },
    6: { type: 6, routeSegment: 'weather',    moduleFolder: 'weather',      translationKey: 'Clima',        showInMainHeader: true,  showInMobileSelector: true },
    8: { type: 8, routeSegment: 'developer',  moduleFolder: 'developer',    translationKey: 'Developer',    showInMainHeader: false, showInMobileSelector: false },
    9: { type: 9, routeSegment: 'zar',        moduleFolder: 'zar',          translationKey: 'infracciones', showInMainHeader: true,  showInMobileSelector: true },
    10:{ type:10, routeSegment: 'red-light',  moduleFolder: 'red-light',    translationKey: 'foto-rojo',    showInMainHeader: true, showInMobileSelector: true },
    11:{ type:11, routeSegment: 'waste',      moduleFolder: 'waste',        translationKey: 'Residuos',     showInMainHeader: true,  showInMobileSelector: false },
    12:{ type:12, routeSegment: 'crosswalk',  moduleFolder: 'crosswalk',    translationKey: 'paso-cebra',   showInMainHeader: true,  showInMobileSelector: false },
    103:{ type:103, routeSegment: 'help',       moduleFolder: 'help',          translationKey: 'ayuda',        showInMainHeader: true,  showInMobileSelector: false },
  };

  /** Mapa tipo de módulo (header) -> segmento de ruta en la URL */
  private readonly MODULE_TYPE_TO_ROUTER_LINK: Record<number, string> = {};

  /** Mapa segmento de ruta en la URL -> tipo de módulo */
  private readonly ROUTER_LINK_TO_MODULE_TYPE: Record<string, number> = {};

  /**
   * Devuelve el tipo de módulo (headerSelect) según la URL actual del router.
   */
  private getCurrentModuleTypeFromUrl(): number | null {
    return this.getModuleTypeFromUrl(this.router.url);
  }

  /**
   * Devuelve el tipo de módulo según una URL arbitraria.
   */
  private getModuleTypeFromUrl(url: string): number | null {
    const cleanUrl = url.split('?')[0];
    const urlSegments = cleanUrl.split('/').filter(s => s);
    let currentModulePath = urlSegments[0] || '';

    // Alias legacy: '/infractions' debe mapearse al módulo 'zar'
    if (currentModulePath === 'infractions') {
      currentModulePath = 'zar';
    }

    const currentModuleType = this.ROUTER_LINK_TO_MODULE_TYPE[currentModulePath];
    return currentModuleType ?? null;
  }

  /**
   * Devuelve la clave de traducción para mostrar el nombre del módulo actual en móvil.
   */
  getModuleTranslationKeyForMobile(moduleType: number): string {
    const def = this.MODULE_DEFINITIONS[moduleType];
    if (!def || !def.showInMobileSelector) {
      return '';
    }
    return def.translationKey;
  }

  panelesChildRoutes =  [
  { label: 'Capacidad', path: 'capacity' },
  { label: 'Personas', path: 'panel-personas' },
  { label: 'Clima', path: 'panel-climaV2' },
  { label:'panel-conteo:',path:'panel-conteo'},
  { label: 'Tramos', path: 'PanelTramo' },
  { label: 'Camiones y trailers', path: 'trucks-trailers' },
  { label: 'Parqueaderos', path: 'parking-panel' },
  { label: 'ZBE', path: 'panel-zbe' },
  { label: 'Matrículas', path: 'panel-matriculas' }
];
  entorno = environment.entorno;

  private getVirtualMunSessionSnapshot(): {
    showMultimunicipio: string | boolean;
    municipiosVirtuales: string | boolean;
  } {
    return {
      showMultimunicipio: this.fse.optenerValor('showMultimunicipio'),
      municipiosVirtuales: this.fse.optenerValor('municipiosVirtuales'),
    };
  }

  LANGS = LANGS_V2;
  languages!: SupportedLanguages;
  translationDialogueIncomingLanguage: { 
    'establecer-como-predeterminado': string,
    'idioma-se-usara-como-predeterminado': string,
    'no-guardar': string,
    'si-usar-predeterminado': string
  } = null;

  @ViewChild('menu') menu: MatMenu;
  @ViewChild(MatMenuTrigger) menuTrigger: MatMenuTrigger; 

  constructor() {
    const fse = this.fse;

    // Inicializa los mapas de tipo <-> segmento de ruta a partir de la definición centralizada
    Object.values(this.MODULE_DEFINITIONS).forEach(def => {
      this.MODULE_TYPE_TO_ROUTER_LINK[def.type] = def.routeSegment;
      this.ROUTER_LINK_TO_MODULE_TYPE[def.routeSegment] = def.type;
    });
    
    if (this.entorno !== 'Production') {
      this.Title.setTitle("SOLFIX Smart City " + this.entorno);
    }
        
    this.language = this.fse.optenerValor('language');
    this.nameUser = fse.optenerValor('dato2');
    this.mail = fse.optenerValor('dato3');
    this.setLanguage();
    this.translate.onLangChange
      .pipe(startWith(this.language))
      .subscribe(() => {
        this.translate.get(this.translateKeys)
          .subscribe((variables) => this.variables = variables);
      })

    this.municipioUserSlider = this.fse.optenerValor('multimunicipio') === 'true';
      this.router.events.subscribe(() => {
      const current = this.router.url;
      const match = this.panelesChildRoutes.find(p =>
        current.includes(p.path)
      );
      if (match) {
        this.selectedPanelPath = match.path;
      }
      this.showPanelesSubmenu = false; 
   });

    this.municipalityTokenService.initialize();
    
  }

  ngOnInit(): void {
    this._updateService.checkUpdates();

    this.initAfterMunicipalityTokenReady();

    this.detectNavigationWithBrowserArrows();

    if (this.router.url === '/') {
      const defaulRoute = this.fse.optenerValor('defaulRoute');
      if (typeof defaulRoute === 'string' && defaulRoute.length > 0) {
        this.router.navigate([defaulRoute]).then(() => {
          this.checkRoute();
        });
      }
    }

    /** Escuchamos la propiedad isMobile que devuelve un boolean que determina si estamos en un dispositivo con dimensiones moviles */
    this._listenDOMChange.isMobile
    .pipe( takeUntilDestroyed(this.$destroyRef) )
    .subscribe( isMobile => this.isMobile = isMobile );

    this.citySearchControl.valueChanges
    .pipe(
      startWith(''),
      debounceTime(200)
    )
    .subscribe(() => {
      this.applyMunicipioListFilters();
    })

    this.fse.getAppState().subscribe((res)=>{
      this.appState = res;
    });

    const rawShow = this.fse.optenerValor('showMultimunicipio');
    const showMultimunicipio = rawShow === 'true';

    if (showMultimunicipio) {
      const rawVirt = this.fse.optenerValor('municipiosVirtuales');
      const ids =
        typeof rawVirt === 'string' && rawVirt.length > 0
          ? rawVirt
              .split(',')
              .map((id) => parseInt(id.trim(), 10))
              .filter((id) => Number.isFinite(id) && id > 0)
          : [];
      this.selectedMunicipios = ids;
      this.isMultipleSelection = true;
      this.showCounterMunicipioVirtual = true;
    }
  }

  ngAfterViewInit(): void {
    this.presetRelease();
  }

  private async initAfterMunicipalityTokenReady(): Promise<void> {
    this.municipalityTokenService.getToken$()
      .pipe(takeUntilDestroyed(this.$destroyRef))
      .subscribe((token) => {
        const roleName = token?.nombre_rol || '---';
        this.userRolName = roleName;
        this.userRolNameSig.set(roleName);
      });

    const isReady = await this.municipalityTokenService.waitUntilReady();
    if (!isReady) {
      return;
    }

    this.userRolName = this.municipalityTokenService.getUserMunicipalityRoleName() || '---';
    this.userRolNameSig.set(this.userRolName);

    this.validateDialogterminosENS();
    this.getCitys();
    this.checkRoute();
  }

  ngOnDestroy(): void {
    this.fse.agregarActualizar('recharge', window.location.pathname);
  }

  /**
   * Abre o cierra el submenu de paneles
   */
  onClickPaneles() {
    this.showPanelesSubmenu = !this.showPanelesSubmenu;
  }

  /**
   * Abre o cierra el submenu de paneles
   * @param event - event de click
   */
  togglePaneles(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.showPanelesSubmenu = !this.showPanelesSubmenu;
  }

  /**
   * Selecciona un panel
   * @param path  - ruta del panel
   */
  selectPanel(path: string) {
    this.selectedPanelPath = path;
    this.showPanelesSubmenu = false;
  }
    
  /**
   * Verifica si es la primera vez que se accede a la plataforma y asigna el idioma por defecto
   * de lo contrario usa el idioma que se encuentra en la caché
   */
  setLanguage() {
    const cacheLang = this.fse.optenerValor('language') as SupportedLanguages | false;
    const browserLang = this.translate.getBrowserLang() as SupportedLanguages;

    if (!cacheLang || !LANGS_V2.includes(cacheLang)) {
      const langToUse = LANGS_V2.includes(browserLang)
        ? browserLang
        : LANGS_V2[0];

      this.translate.setDefaultLang(langToUse);
      this.changeLanguage(langToUse);
    } else {
      this.translate.setDefaultLang(cacheLang);
      this.changeLanguage(cacheLang);
    }
  }

  /**
   * Verifica si hay una nueva actualización
   */
  presetRelease() {
    const newUpdateMessage = this._updateService.shouldShowMessage();;
    if (newUpdateMessage && Boolean(newUpdateMessage)) {
      this.acercaDe.getCurrentVersionChanges();
    }
  }

  /** Detecta la navegacion por medio de las flechas del navegador o las del mouse (en caso de que las tenga) */
  detectNavigationWithBrowserArrows() {

    this.router.events
    .pipe( filter( event => event instanceof NavigationStart || event instanceof NavigationEnd ) )
    .subscribe((event: NavigationStart) => {

      if (event instanceof NavigationStart) {
        if (event.navigationTrigger === 'popstate') {
          if ( event.url === '/' || event.url === '' || window.location.href.includes('auth#state') ) {
              this.router.navigate(['/' + this.router.url]);
          } else {
              const moduleType = this.getModuleTypeFromUrl(event.url);
              if (moduleType && this.headerSelect !== moduleType) {
                this.fse.agregarActualizar('recharge', event.url);
                this.changeRouteParent(moduleType);
              }
          }
          
        }
      }
    });
  }

  /**
   * Refrescar lista de municipios
   */
  refreshCityList() {
    this.applyMunicipioListFilters();
  }

  /**
   * Inicializar lista municipios
   */
  initCity() {
    this.results = this.ListMun;
  }

  /**
   * Busqueda de municipios
   */
  search(value: string) {
    this.citySearchControl.setValue(value ?? '', { emitEvent: false });
    this.applyMunicipioListFilters();
  }

  /**
   * Cambiar municipio
   * @param event parametro de busqueda
   */
  onChangeEvent(event: any) {
    this.search(event.target.value);
  }

  /**
   * Configura los módulos que puede ver el municipio
   */
  setHeaders() {
    const modules = this.fse.optenerValor('paquetes');
    const routePermissions = this.fse.optenerValor('dato43');

    if (typeof modules !== 'string' || typeof routePermissions !== 'string') {
      this.headers = [];
      return;
    }

    const routePermissionsArray = routePermissions.split(',').map((permission: string) => permission.trim());

    // Construimos los headers a partir de la definición centralizada de módulos
    this.headers = Object.values(this.MODULE_DEFINITIONS)
      .filter(def => def.showInMainHeader)
      .map<MenuHeader>(def => ({
        routerLink: def.routeSegment,
        type: def.type,
        name: def.translationKey,
        permission: modules,
        hasAccess: false
      }));

    // Precarga las rutas del módulo
    this.headers.forEach((header) => {
      const def = this.MODULE_DEFINITIONS[header.type];
      ROUTING_MODULE_LOADERS[def.moduleFolder]().then(x => {
        const availableRoutes = x.routes.filter(route => route.path != '' && routePermissionsArray.includes(route.data.permission.toString()));
        header.hasAccess = modules.split(',').includes(header.type.toString()) && availableRoutes.length >= 1;
      });
    })
    
  }

  /**
   * Verifica si el usuario tiene acceso al módulo especificado
   * @param moduleId ID del módulo a verificar
   * @returns
   */
  hasModuleAccess(moduleId: number): boolean {
    const modules = this.fse.optenerValor('paquetes') || '';
    return modules.split(',').includes(moduleId.toString());
  }

  /**
   * Activa el header principal y los subheader dependiendo de la ruta actual
   */
  checkRoute() {
    if (this.router.url === '/') return;

    const currentModuleType = this.getCurrentModuleTypeFromUrl() ?? 6;
    this.headerSelect = currentModuleType;
    this.changeRouteParent(this.headerSelect);
  }

  /**
   * Trae los municipios disponibles
   */

  getCitys() {

    forkJoin({
      cities: this.db.Municipios(),
      fotoRojo: this.db.getMunicipalitiesWithFotoRojo().pipe(
        catchError(() => of({ ok: false, ids: [] as number[] }))
      ),
      zar: this.db.getMunicipalitiesWithZar().pipe(
        catchError(() => of({ ok: false, ids: [] as number[] }))
      ),
      pasoCebra: this.db.getMunicipalitiesWithPasoCebra().pipe(
        catchError(() => of({ ok: false, ids: [] as number[] }))
      ),
      residuos: this.db.getMunicipalitiesWithResiduos().pipe(
        catchError(() => of({ ok: false, ids: [] as number[] }))
      ),
      guardian: this.db.getMunicipalitiesWithGuardian().pipe(
        catchError(() => of({ ok: false, ids: [] as number[] }))
      ),
    }).subscribe(({ cities, fotoRojo, zar, pasoCebra, residuos, guardian }: any) => {
      const { municipios, userInfo } = cities;

      this.municipiosConFotoRojoIds = Array.isArray(fotoRojo?.ids) ? fotoRojo.ids : [];
      this.municipiosConZarIds = Array.isArray(zar?.ids) ? zar.ids : [];
      this.municipiosConPasoCebraIds = Array.isArray(pasoCebra?.ids) ? pasoCebra.ids : [];
      this.municipiosConResiduosIds = Array.isArray(residuos?.ids) ? residuos.ids : [];
      this.municipiosConGuardianIds = Array.isArray(guardian?.ids) ? guardian.ids : [];
      this.ListMun = municipios.filter((mun: any) => mun.IdMunicipio !== configuracion.id_multimunicipio);
      this.ListDataUSer = userInfo;
      this.results = this.ListMun;
      
      this.fse.agregarActualizar('dato1', this.ListDataUSer.accessToken);
      this.fse.agregarActualizar('multimunicipio', `${this.ListDataUSer.busquedaMultimunicipio ?? false}`);
      this.fse.agregarActualizar('ValoresDegradadoMapa', `${this.ListDataUSer.ValoresDegradadoMapa ?? false}`);
      this.fse.agregarActualizar('Min_Max_Descarga', `${this.ListDataUSer.Min_Max_Descarga ?? false}`);
      this.fse.setUserCities(municipios);

      if(!this.fse.optenerValor('dato2')) {
        this.getDataUser();
      }

      const selectedMunicipality = this.ListMun.find((mun) => {
        const selected = Number(this.fse.optenerValor('dato4'));

        return mun.IdMunicipio === selected;
      });

      const virtualPersisted = this.fse.optenerValor('showMultimunicipio') === 'true';

      if (virtualPersisted) {
        let primary: Municipio | undefined;
        const defaultRaw = this.fse.optenerValor('defaultBeforeMuniVirtual');
        if (typeof defaultRaw === 'string' && defaultRaw.length > 0) {
          try {
            const parsed = JSON.parse(defaultRaw) as Municipio;
            if (parsed?.IdMunicipio) {
              primary = this.ListMun.find((m) => m.IdMunicipio === parsed.IdMunicipio);
            }
          } catch {
            /* ignore JSON inválido */
          }
        }
        if (!primary && this.selectedMunicipios.length > 0) {
          primary = this.ListMun.find((m) => this.selectedMunicipios.includes(m.IdMunicipio));
        }
        if (!primary && selectedMunicipality) {
          primary = selectedMunicipality;
        }
        if (this.selectedMunicipios.length === 0 && primary) {
          this.selectedMunicipios = [primary.IdMunicipio];
        }
        if (primary) {
          this.Munselect = primary;
          this.emitValueCity(primary, false, { skipMunicipiosMutation: true });
        } else {
          this._loaderService.hideSpinner();
        }
      } else if (selectedMunicipality) {
        this.Munselect = selectedMunicipality;
        this.emitValueCity(this.Munselect);
      }

      this.fse.setAppState(true);

      if (this.Munselect?.IdMunicipio) {
        this.listenNotificationService(this.Munselect.IdMunicipio);
      }

      this.municipioUserSlider = this.fse.optenerValor('multimunicipio') === 'true';
    });

  }

  /** Establecer y escuchar comunicacion via a sockets con la api de notificaciones */
  listenNotificationService( idMunicipality: number ) {
    if (!this.isMultipleSelection && idMunicipality){
      this._notificationService.listenNotification(idMunicipality);
    }
  }

  /**
   * Obtener datos del usuario
   * @returns 
   */
  getDataUser(){
    this.nameUser = this.ListDataUSer.dato2;
    this.mail = this.ListDataUSer.dato3;

    this.fse.agregarActualizar('configuracion', this.ListDataUSer.Configuracion);

    this.fse.agregarActualizar('dato2', this.ListDataUSer.dato2);
    this.fse.agregarActualizar('dato3',this.ListDataUSer.dato3 + '');

    this.fse.agregarActualizar('dato38', ''+ this.ListDataUSer.CantCamaras);
    this.fse.agregarActualizar('dato39',''+ this.ListDataUSer.CantDescargas);
    this.fse.agregarActualizar('manualUsuario',''+ this.ListDataUSer.ManualUsuario);

    this.fse.agregarActualizar('dato42', this.ListDataUSer.nuevo +'');
    this.fse.agregarActualizar('dato7', this.ListDataUSer.lat);
    this.fse.agregarActualizar('dato8', this.ListDataUSer.lng);
    this.fse.agregarActualizar('configMatr', this.ListDataUSer.configuracion_matr);

    return true;
  }

  /**
   * Abre el dialogo de perfil de usuario que permite cambiar la informacion del perfil o contraseña
   */
  OpenProfile() {
    let userInfo = {
      name: this.fse.optenerValor('dato2'),
      mail: this.fse.optenerValor('dato3'),
      username: this.fse.optenerValor('dato44'),
    };
    this.dialog.open(PerfilUsarioComponent, {
      width: this.isMobile ? '100%' : '40%',
      panelClass: 'width-max-mat-dialog',
      autoFocus: false,
      data: userInfo,
    });
  }

  openDefaultRoutesDialog() {
    this.dialog.open(DialogoRutaModoPredeterminadoComponent, {
      width: this.isMobile ? '100%' : '720px',
      maxWidth: '95vw',
      panelClass: ['width-max-mat-dialog', 'default-routes-dialog-panel'],
      autoFocus: false,
    });
  }

  /**
   * Muestra la version actual de la plataforma( version establecida en package.json)
   */
  showAbout() {
    this.acercaDe.aboutSwal.fire();
  }

  /**
   * Cierra la sesion actual del usuario
   */
  closeSession() {
    this.tokenRefreshService.stop();
    this.fse.closeSession();
    this.msalService.logoutRedirect().subscribe(() => {
      this.router.navigate(["/"]);
    });
  }

  /**
   * Abre el diaglo ConfMunicipioComponent para visualizar la informacion del municipio seleccionado
   */
  openDialgCity() {
    this.dialog.open(ConfMunicipioComponent, {
      width: this.isMobile ? '100%' : '40%',
      panelClass: 'width-max-mat-dialog',
      autoFocus: false,
      data: { IdMunicipio: this.Munselect.IdMunicipio },
    });
  }

  /***
   * Cambia el lenguaje de la plataforma
   */
  async selectLanguage(language: string) {

    const isSameLanguage = language === this.language;

    // Obtenemos el texto de traduccion si el lenguaje al que se desea cambiar es diferente al lenguaje actual establecido
    let translations = {};
    let translationMessageText = '';
    if ( !isSameLanguage ) {
      this._loaderService.showSpinner();
      translations = await lastValueFrom(this.translate.getTranslation(language));
      translationMessageText = !this.translationDialogueIncomingLanguage ? translations['traducir_mensaje'] : this.variables['traducir_mensaje'];
      this._loaderService.hideSpinner();
    }

    const alertResult = await this._messageService.dialogMessage(
      'question',
      this.getTranslationText('establecer-como-predeterminado'), 
      { 
        text: this.getTranslationText('establecer-como-predeterminado'),
        denyButtonText:  this.getTranslationText('no-guardar'),
        confirmButtonText: this.getTranslationText('si-usar-predeterminado'),
        cancelButtonText: `${translationMessageText} - ${ !this.translationDialogueIncomingLanguage ? language : this.language }`,
        showDenyButton: true,
        showCancelButton: !isSameLanguage,
        heightAuto: false,
        preConfirm: () => {
          this.translationDialogueIncomingLanguage = null;
          this._loaderService.showSpinner();
          this.setLanguageDefault(language).subscribe(response => {
            this._loaderService.hideSpinner();
            if ( response ) {
              this.changeLanguage(language);
              this._messageService.SwalMessage('success', this.variables['mensaje_confirmacion']);              
            } else {
              this._messageService.SwalMessage('error', this.variables['error_contacto']);
            }
          });
      },
      preDeny: () => {
        this.translationDialogueIncomingLanguage = null;
        this.changeLanguage(language);
      }  
    });

    this.handleCancelButtonModalSelectLanguage(alertResult, language, translations);

  }

  /**
   * Devuelve el texto de traduccion para la clave especificada.
   * Si translationDialogueIncomingLanguage tiene un valor, devuelve el texto de traduccion
   * correspondiente a la clave desde ese objeto, de lo contrario devuelve el valor
   * de la clave desde el objeto variables.
   * @param keyName Clave del texto de traduccion
   * @returns Texto de traduccion correspondiente a la clave o valor por defecto
   */
  getTranslationText( keyName: string ): string {
    return this.translationDialogueIncomingLanguage ? this.translationDialogueIncomingLanguage[keyName] : this.variables[keyName];
  }

  
  /**
   * Establece el lenguaje por defecto en la base de datos.
   * Emite un observable que se resuelve con un booleano que indica
   * si se ha establecido correctamente el lenguaje por defecto.
   * @param language lenguaje que se desea establecer como predeterminado
   * @returns
   */
  setLanguageDefault(language: string): Observable<boolean> {
    return this.db.ConfigurarIdiomaDefault(language).pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }

  /**
   * Maneja el caso en que se cancela el modal de seleccion de idioma
   * y restablece el estado de la variable translationDialogueIncomingLanguage
   * y vuelve a llamar al metodo selectLanguage con el lenguaje
   * especificado
   * @param alertResult resultado de la alerta
   * @param language lenguaje seleccionado
   * @param translations traducciones del lenguaje
   */
  handleCancelButtonModalSelectLanguage( 
    alertResult: SweetAlertResult<any>, 
    language: string, 
    translations: { [key: string]: string } 
  ) {

    if ( alertResult.isDismissed && alertResult.dismiss === Swal.DismissReason.cancel ) {
      if ( this.translationDialogueIncomingLanguage ) {
        this.translationDialogueIncomingLanguage = null;
      } else {
        this.translationDialogueIncomingLanguage = {
          'establecer-como-predeterminado': translations['establecer-como-predeterminado'],
          'idioma-se-usara-como-predeterminado': translations['idioma-se-usara-como-predeterminado'],
          'no-guardar': translations['no-guardar'],
          'si-usar-predeterminado': translations['si-usar-predeterminado']
        }
      }
      this.selectLanguage(language);
      return;
    }
    this.translationDialogueIncomingLanguage = null;

  }
 
  /**
   * Cambia el lenguaje de la plataforma
   * @param language Codigo del lenguaje
   */
  changeLanguage(language: string) {
    this.translate.use(language);
    this.fse.setLanguage(language);
    this.language = language;
  }

  /**
   * Cambia la ruta de la plataforma segun el valor de urlRouting, si executeChangeRoutes es true, tambien cambia las rutas hijas.
   * @param urlRouting El valor de la ruta que se quiere cambiar, los valores posibles son:
   * - 1: /traffic
   * - 2: /management
   * - 3: /admin
   * - 4: /telemetry
   * - 9: /zar
   * - 6: /weather
   * - 10: /red-light
   * - 8: /developer
   * - 11: /waste
   * @param executeChangeRoutes Si es true, se cambian las rutas hijas, si es false, solo se cambia la ruta principal. Por defecto es true.
   * @returns Un promise que se resuelve con las rutas hijas que se han configurado.
   */
  onModuleHeaderClick(urlRouting: number, event?: Event): void {
    const currentModuleType = this.getCurrentModuleTypeFromUrl();
    if (currentModuleType === urlRouting) {
      event?.preventDefault();
      event?.stopPropagation();
      return;
    }

    if (currentModuleType != null) {
      this.headerSelect = currentModuleType;
    }

    this.fse.deleteVariable('routeInit');
    this.changeRouteParent(urlRouting);
  }

  /**
   * Cambia la ruta principal y las rutas hijas
   * @param urlRouting - El valor de la ruta que se quiere cambiar
   * @param executeChangeRoutes - Si es true, se cambian las rutas hijas
   * @returns
   */
  changeRouteParent(urlRouting: number, executeChangeRoutes = true): Promise<any> {
    let permission = this.fse.optenerValor('dato43');

    if (typeof permission !== 'string') {
      permission = '';
    }

    permission = permission.split(',');

    return new Promise((resolve) => {
      const def = this.MODULE_DEFINITIONS[urlRouting];
      if (!def) {
        resolve(undefined);
        return;
      }

      this.headerSelect = def.type;

      ROUTING_MODULE_LOADERS[def.moduleFolder]().then(x => {
        this.ChildRoutes = x.routes.filter(route => route.path != '' && permission.includes(route.data.permission.toString()));
        if (executeChangeRoutes) {
          this.changeRoutes(def.routeSegment, this.ChildRoutes);
        }
        resolve(this.ChildRoutes);
      });
    });
  }
  
  /**
   * Obtener rutas
   * @param routeChild parametro de la ruta
   * @returns 
   */
  getRoute(routeChild: string) {
    const def = this.MODULE_DEFINITIONS[this.headerSelect];
    const segment = def ? def.routeSegment : 'admin';
    return `/${segment}/${routeChild}`;
  }

  /**
   * Manual de usuario
   */
  downloadUserManual() {
    this.db
      .obtenerUrlManual()
      .pipe(first())
      .subscribe(({ url }: { url: string }) => {
        this.manualAnchor.nativeElement.setAttribute('href', url);
        this.manualAnchor.nativeElement.click();
      });
  }

  /**
   * Activa o desactiva la selección múltiple al seleccionar "Todos".
   */
  toggleAllSelection(): void {
    this.isMultipleSelection = !this.isMultipleSelection;
    this.showCounterMunicipioVirtual = this.isMultipleSelection;

    if (!this.isMultipleSelection) {
        this.selectedMunicipios = [];
        this.fse.agregarActualizar('municipiosVirtuales', '');
        this.fse.agregarActualizar('showMultimunicipio', '');    
        const muni = JSON.parse(this.fse.optenerValor('defaultBeforeMuniVirtual'));
        const municipioSeleccionado = muni ?? this.Munselect;
        this.emitValueCity(municipioSeleccionado);
        this.citySearchControl.reset();
    } else {
      if (this.Munselect && this.Munselect.IdMunicipio) {
        this.selectedMunicipios.push(this.Munselect.IdMunicipio);
        setTimeout(() => {
          this.emitValueCity(this.Munselect);
        }, 100);
      }
    }

    if (this.menuTrigger && this.menuTrigger.menuOpen) {
      this.menuTrigger.closeMenu();
      setTimeout(() => {
          this.menuTrigger.openMenu();
      }, 200);
    }
  }

  /** Selección de categoría de filtro y aplicación inmediata sobre el listado. */
  selectMunicipioFilterCategory(categoryId: string): void {
    this.selectedMunicipioFilterCategory =
      this.selectedMunicipioFilterCategory === categoryId ? null : categoryId;
    this.applyMunicipioListFilters();
  }

  /** Muestra u oculta el buscador y las categorías del panel. */
  toggleMunicipioFilters(): void {
    this.showMunicipioFilters = !this.showMunicipioFilters;
  }

  /** Aplica búsqueda y filtro de categoría activos sobre ListMun. */
  applyMunicipioListFilters(): void {
    let list = this.ListMun ?? [];

    if (this.selectedMunicipioFilterCategory === 'fotoRojo') {
      const ids = new Set(this.municipiosConFotoRojoIds.map((id) => Number(id)));
      list = list.filter((mun) => ids.has(Number(mun.IdMunicipio)));
    } else if (this.selectedMunicipioFilterCategory === 'zar') {
      const ids = new Set(this.municipiosConZarIds.map((id) => Number(id)));
      list = list.filter((mun) => ids.has(Number(mun.IdMunicipio)));
    } else if (this.selectedMunicipioFilterCategory === 'pasoCebra') {
      const ids = new Set(this.municipiosConPasoCebraIds.map((id) => Number(id)));
      list = list.filter((mun) => ids.has(Number(mun.IdMunicipio)));
    } else if (this.selectedMunicipioFilterCategory === 'residuos') {
      const ids = new Set(this.municipiosConResiduosIds.map((id) => Number(id)));
      list = list.filter((mun) => ids.has(Number(mun.IdMunicipio)));
    } else if (this.selectedMunicipioFilterCategory === 'guardian') {
      const ids = new Set(this.municipiosConGuardianIds.map((id) => Number(id)));
      list = list.filter((mun) => ids.has(Number(mun.IdMunicipio)));
    }

    const value = (this.citySearchControl.value || '').toString().trim();
    if (value.length >= 2) {
      const search = value.toLowerCase();
      list = list.filter((mun) => mun.Nombre?.toLowerCase().includes(search));
    }

    this.results = list;
  }

  /** Limpia búsqueda y categoría activas en el panel. */
  clearMunicipioFiltersUi(): void {
    this.citySearchControl.setValue('', { emitEvent: false });
    this.selectedMunicipioFilterCategory = null;
    this.applyMunicipioListFilters();
  }

  /** Al abrir el selector: limpia filtros y posiciona el municipio actual. */
  onMunicipioMenuOpened(): void {
    this.clearMunicipioFiltersUi();
    this.positionCityInTheCitiesMenu();
  }

  /**
   * Selecciona "Todos" los municipios o el municipio por defecto junto con otros hasta el máximo permitido.
   */
  toggleAllSelectionAll(): void {
    if (this.selectedMunicipios.length === this.maxMunicipiosSelected) {
      const muni = JSON.parse(this.fse.optenerValor('isAllSelectionMunicipio') || this.fse.optenerValor('defaultBeforeMuniVirtual'));
      let municipioSeleccionado = muni?.[0] ?? null;
  
      if (municipioSeleccionado && !Array.isArray(municipioSeleccionado)) {
        municipioSeleccionado = this.ListMun.filter(mun => mun.IdMunicipio === municipioSeleccionado);
      }

      if (municipioSeleccionado) {
        this.selectedMunicipios = Array.isArray(municipioSeleccionado) ? municipioSeleccionado.map(mun => mun.IdMunicipio) : [municipioSeleccionado.IdMunicipio];
        this.emitValueCity(municipioSeleccionado[0], true);
      }

    } else {
      const municipiosAdicionales = this.ListMun
        .filter((mun) => !this.selectedMunicipios.includes(mun.IdMunicipio))
        .slice(0, this.maxMunicipiosSelected - this.selectedMunicipios.length);

      this.selectedMunicipios.push(...municipiosAdicionales.map((mun) => mun.IdMunicipio));
      this.emitValueCity(this.Munselect, true);
    }

    if (this.menuTrigger && this.menuTrigger.menuOpen) {
      this.menuTrigger.closeMenu();
      setTimeout(() => {
          this.menuTrigger.openMenu();
      }, 500);
    } 
  }

  /**
   * Maneja el clic sobre un municipio en modo sin checkboxes.
   * @param mun Municipio seleccionado.
   */
  onMunicipioClick(mun: Municipio): void {
    if (!this.showCounterMunicipioVirtual) {
      this.emitValueCity(mun);
    }
  }

  onMunicipioCheckboxChange(mun: Municipio): void {
    this.emitValueCity(mun);
    this.changeStateMenuTriggerListMunicipalities();
  }

  onMunicipioSelectionChange(event: MatSelectionListChange): void {
    const selected = event.options?.[0]?.value as Municipio | undefined;
    if (!selected) {
      return;
    }

    this.emitValueCity(selected);
  }

  /**
   * Envía la actualización del municipio seleccionado a todos los suscriptores, cambio de permisos.
   * @param munSelect Municipio seleccionado.
   */
  emitValueCity(
    munSelect: Municipio,
    isAllSelection: boolean = false,
    options?: { skipMunicipiosMutation?: boolean }
  ): void {

    if (this.isMultipleSelection && !options?.skipMunicipiosMutation) {
      const index = this.selectedMunicipios.indexOf(munSelect.IdMunicipio);
  
      if (index > -1) {
        if (this.selectedMunicipios.length > 1) {
          if(!isAllSelection) this.selectedMunicipios.splice(index, 1);
        }
      } else if (this.selectedMunicipios.length < this.maxMunicipiosSelected) {
        this.selectedMunicipios.push(munSelect.IdMunicipio);
      } else {
        this.selectedMunicipios = [munSelect.IdMunicipio];
      }

      if (this.selectedMunicipios.length === 1) {
        this.fse.agregarActualizar('isAllSelectionMunicipio', JSON.stringify(this.selectedMunicipios));
      }

      this.fse.agregarActualizar('municipiosVirtuales', this.selectedMunicipios.join(','));
      this.fse.agregarActualizar('showMultimunicipio', 'true');
    }

    if (!this.showCounterMunicipioVirtual) {
        this.menuTrigger.closeMenu();
    }

    this._loaderService.showSpinner();

    this.appState = false;

    const idMunicipioValidatedMultimunicipio = this.isMultipleSelection ? configuracion.id_multimunicipio : munSelect.IdMunicipio;

    // Siempre revalida token/permisos al cambiar municipio para evitar usar permisos de un contexto anterior.
    this.db.getModulosPermisosRol(null, idMunicipioValidatedMultimunicipio).subscribe({
      next: ({ accessToken, refreshToken }) => {

        Promise.all([
          this.municipalityTokenService.verifyAndStoreToken(accessToken),
          this.municipalityTokenService.verifyToken(refreshToken),
        ]).then(() => {
          updateTokensAndRefresh(
            this.fse,
            this.municipalityTokenService,
            this.tokenRefreshService,
            accessToken, 
            refreshToken, 
            'schedule'
          );
          this.userRolName = this.municipalityTokenService.getUserMunicipalityRoleName() || '---';
          this.userRolNameSig.set(this.userRolName);

          this.setMunicipio(munSelect);
        }).catch(() => {
          this.appState = false;
          this._notificationService.closeConnection();
          this._loaderService.hideSpinner();
        });

      },
      error: () => {
        this.appState = false;
        this._notificationService.closeConnection();
        this._loaderService.hideSpinner();
      }
    });
  }
  
  setMunicipio(munSelect: Municipio) {
    this.db.getInfoInicialMunicipio().subscribe({
      next: ({ municipio }) => {

        this.citySearchControl.reset();

        if(!this.isMultipleSelection) {
          this.fse.agregarActualizar('defaultBeforeMuniVirtual', JSON.stringify(munSelect));
          this.MunselectSaved = munSelect;
        }

        this.Munselect = munSelect;

        this.fse.agregarActualizar('dato5', munSelect.Nombre);
        this.fse.agregarActualizar('dato5', munSelect.Nombre);
        this.fse.setCity(this.Munselect.IdMunicipio.toString());

        // # Viene de la petición
        this.fse.agregarActualizar('dato7', municipio.Latitud);
        this.fse.agregarActualizar('dato8', municipio.Longitud);

        this.fse.agregarActualizar('utc_offset', municipio.utc_offset);
        this.fse.agregarActualizar('dato41', municipio.zona_horaria);
        this.fse.agregarActualizar('zona_js', findIana(municipio.zona_horaria)[0]);
        
        if (this.isMultipleSelection) {
          this.fse.agregarActualizar('municipiosVirtuales', this.selectedMunicipios.join(','));
          this.fse.agregarActualizar('showMultimunicipio', 'true');
        }

        this.setHeaders();
        this.setRoute();
        this.refreshActiveSubmodulePermissions();
        setTimeout(() => this.refreshActiveSubmodulePermissions(), 0);

        this.appState = true;
        this.listenNotificationService(this.Munselect.IdMunicipio);
        this._loaderService.hideSpinner();
      },
      error: () => {
        this.appState = false;
        this._notificationService.closeConnection();
        this._loaderService.hideSpinner();
      }
    });
  }

  private refreshActiveSubmodulePermissions(): void {
    const currentUrl = this.router.url.split('?')[0];
    const urlSegments = currentUrl.split('/').filter(s => s);
    const currentSubPath = urlSegments[1] || '';

    if (!currentSubPath || !Array.isArray(this.ChildRoutes) || this.ChildRoutes.length === 0) {
      return;
    }

    const activeSubmodule = this.ChildRoutes.find((route: any) => route.path === currentSubPath);
    const activeSubmoduleId = Number(activeSubmodule?.data?.permission);

    if (!Number.isFinite(activeSubmoduleId)) {
      return;
    }

    this.permissionsService.cleanRoutes();
    this.permissionsService.setActiveSubmodule(activeSubmoduleId);

    this.db.getSubmodulesPermissions([activeSubmoduleId]).subscribe({
      next: (response: any[]) => {
        if (!Array.isArray(response) || response.length === 0) {
          this.permissionsService.setRoutePermissions([], activeSubmoduleId);
          this.permissionsService.setRouteSpecialPermissions([], activeSubmoduleId);
          return;
        }

        response.forEach((item: any) => {
          const idSubmodule = Number(item?.idSubmodulo ?? activeSubmoduleId);
          if (!Number.isFinite(idSubmodule)) {
            return;
          }

          const permisos: number[] = item?.permisos
            ? String(item.permisos)
              .split(',')
              .map((permission: string) => Number(permission))
              .filter((permission: number) => !Number.isNaN(permission))
            : [];

          let permisosEspeciales: string[] = [];
          if (item?.permisos_especiales) {
            if (Array.isArray(item.permisos_especiales)) {
              permisosEspeciales = item.permisos_especiales
                .map((permission: any) => permission?.key_identity)
                .filter((permission: string) => !!permission);
            } else {
              try {
                const parsed = JSON.parse(item.permisos_especiales);
                if (Array.isArray(parsed)) {
                  permisosEspeciales = parsed
                    .map((permission: any) => permission?.key_identity)
                    .filter((permission: string) => !!permission);
                }
              } catch {
                permisosEspeciales = [];
              }
            }
          }

          this.permissionsService.setRoutePermissions(permisos, idSubmodule);
          this.permissionsService.setRouteSpecialPermissions(permisosEspeciales, idSubmodule);
        });
      },
      error: () => {
        this.permissionsService.setRoutePermissions([], activeSubmoduleId);
        this.permissionsService.setRouteSpecialPermissions([], activeSubmoduleId);
      }
    });
  }

  /**
   * Validar rutas a las que puede acceder el usuario.
   * Al cambiar de municipio: mantiene módulo/submódulo si hay permiso; si no, primer submódulo del mismo módulo; si no hay módulo, primer submódulo del primer módulo.
   * En F5 / deep-link: si el router aún está en `/`, usa routeInit (o pathname) guardado al arrancar.
   */
  setRoute(): void {
    const routeInitRaw = this.fse.optenerValor('routeInit');
    const routeInit = typeof routeInitRaw === 'string' ? routeInitRaw : '';
    const currentUrl = this.router.url.split('?')[0];
    const effectivePath = this.resolveEffectiveNavigationPath(currentUrl, routeInit);
    const urlSegments = effectivePath.split('/').filter(s => s);
    const currentModulePath = urlSegments[0] || '';
    const currentSubPath = urlSegments[1] || '';

    const paquetes = (this.fse.optenerValor('paquetes') || '').split(',').map(s => s.trim());
    const dato43 = (this.fse.optenerValor('dato43') || '').split(',').map(s => s.trim());
    const currentModuleType = this.ROUTER_LINK_TO_MODULE_TYPE[currentModulePath];
    const hasCurrentModuleAccess = currentModuleType != null && paquetes.includes(currentModuleType.toString());

    // Módulo + submódulo: mantener (o primer submódulo permitido del mismo módulo)
    if (hasCurrentModuleAccess && currentSubPath) {
      this.changeRouteParent(currentModuleType, false).then((childRoutes: any[]) => {
        const permStr = (p: any) => (p?.data?.permission ?? '').toString();
        const currentRoute = childRoutes.find(r => r.path === currentSubPath);
        const hasSubmoduleAccess = currentRoute && dato43.includes(permStr(currentRoute));

        let targetPath: string | null = null;
        if (hasSubmoduleAccess) {
          targetPath = `${currentModulePath}/${currentSubPath}`;
        } else {
          const firstAllowed = childRoutes.find(r => dato43.includes(permStr(r)));
          targetPath = firstAllowed ? `${currentModulePath}/${firstAllowed.path}` : null;
        }

        if (targetPath) {
          this.fse.agregarActualizar('routeInit', targetPath);
          this.changeRouteParent(currentModuleType);
          return;
        }
        this.redirectToFirstModuleAndSubmodule();
      });
      return;
    }

    // Solo módulo (ej. /developer): primer submódulo de ese módulo
    if (hasCurrentModuleAccess && !currentSubPath) {
      this.fse.deleteVariable('routeInit');
      this.changeRouteParent(currentModuleType);
      return;
    }

    this.redirectToFirstModuleAndSubmodule();
  }

  /**
   * Cuando el router aún reporta `/` (F5 / carga), usa routeInit o el pathname real del navegador.
   */
  private resolveEffectiveNavigationPath(routerUrl: string, routeInit: string): string {
    const routerPath = (routerUrl || '').split('?')[0];
    const routerSegments = routerPath.split('/').filter(Boolean);
    if (routerSegments.length > 0) {
      return routerPath;
    }

    if (routeInit && routeInit !== '/' && routeInit !== '/auth') {
      return routeInit;
    }

    const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
    if (pathname && pathname !== '/' && pathname !== '/auth') {
      return pathname;
    }

    return routerPath || '/';
  }

  /**
   * Redirige al primer submódulo del primer módulo al que el usuario tiene permiso (paquetes y dato43).
   * No usa ruta predeterminada: esa solo aplica al iniciar sesión (app.setRoutes).
   */
  private redirectToFirstModuleAndSubmodule(): void {
    const firstModule = this.headers.find((res) => {
      const permission = res.permission;
      return (permission as any).toString().split(',').includes(res.type.toString());
    });

    if (!firstModule) return;

    this.changeRouteParent(firstModule.type).then(childRoutes => {
      const permission = (this.fse.optenerValor('dato43') || '').split(',').map((s: string) => s.trim());
      const permissionRol = childRoutes.find((res) =>
        permission.includes((res.data?.permission ?? '').toString())
      );
      const navigate = permissionRol
        ? `${firstModule.routerLink}/${permissionRol.path}`
        : firstModule.routerLink;
      this.fse.agregarActualizar('defaulRoute', firstModule.routerLink);
      this.router.navigate([navigate]).then(() => this.checkRoute());
    });
  }

  /**
   * Metodo que realiza correctamente la navegacion cuando se cambia de ruta o cuando se invoca
   * @param firstModule string que representa el nombre de un modulo
   * @param childRoutes arreglo de rutas hijas
   */
  async changeRoutes(firstModule: string, childRoutes: any[]) {
    const permission = this.fse.optenerValor("dato43").split(",");
    const permissionRol = childRoutes.find((res) => {
      return permission.includes(res.data.permission.toString());
    });

    const navigate = permissionRol !== undefined ? `${firstModule}/${permissionRol.path}` : `${firstModule}`;
    const routeSavedSession = this.fse.optenerValor('recharge');
    const routeInit = this.fse.optenerValor('routeInit');

    /**
     * Valida si la propiedad "routeSavedSession" contiene algo
     * Si lo tiene determina a que ruta debe ir y elimina la variable de sesión "recharge"
     * Si esta vacia realiza la navegacion a la ruta por defecto
     */
    if ( routeSavedSession != '' ) {

      routeSavedSession === this.router.url
      ? await this.router.navigate([this.fse.optenerValor('recharge')]) 
      : await this.router.navigateByUrl(window.location.pathname); 
      this.fse.deleteVariable('recharge');
      this.fse.deleteVariable('routeInit');

    } else {

      if ( routeInit ) {

        // Ajustar el header según el módulo al que apunta routeInit
        const moduleTypeFromRouteInit = this.getModuleTypeFromUrl(routeInit);
        if (moduleTypeFromRouteInit && this.headerSelect !== moduleTypeFromRouteInit) {
          this.changeRouteParent(moduleTypeFromRouteInit, false);
        }
        // Navegar por segmentos: 'management/calleCliente' -> ['management','calleCliente'] para ir a /management/calleCliente
        const segments = routeInit.split('/').filter(Boolean);
        await this.router.navigate(segments);
        // Borrar después de navegar para que una segunda llamada a changeRoutes (p. ej. por eventos del router) siga viendo routeInit y no redirija al primer submódulo
        this.fse.deleteVariable('routeInit');

      } else {
        this.router.navigate([ navigate ]);
      }

    }
  }

 /**
 * Redirecciona a la primera ruta disponible
 */
  redirectToFirstRoute(): void {
    this.redirectToFirstModuleAndSubmodule();
  }

  /**
   * Redireccionar a la modificacion de usuario de azure
   * @param userFlowRequest parametro de validacion de autenticacion
   */
  redirectAzure(userFlowRequest?: RedirectRequest | PopupRequest) {
    if (this.msalGuardConfig.authRequest) {
        this.authService.loginRedirect({ ...this.msalGuardConfig.authRequest, ...userFlowRequest } as RedirectRequest);
    } else {
        this.authService.loginRedirect(userFlowRequest);
    }
  }

  /**
   * Abre el dialogo de apliciones
   */
  viewApplications() {
    this.dialog.open(InicializadorAppsComponent,{ 
      panelClass: 'width-max-mat-dialog',
      width: '40%', 
      autoFocus: false
    });
  }

  /** Cierra la navegación lateral */
   closeSidenav() {
    if ( this.sidenav.opened ) this.sidenav.close();
  }

  /**
   * Mostrar u ocultar menu headers en dispositivo movil
   */
  showHeaders(){
    if(this.showOrHide) {
      this.showOrHide = false;
    }
    else{
      this.showOrHide = true;
    }
  }

  /**
   * Posiciona el foco en la ciudad selecionada por el usuario (hace scroll automatico), en el menu de ciudades 
   */
  positionCityInTheCitiesMenu() {
    const municipalityId = this.showCounterMunicipioVirtual
      ? this.selectedMunicipios?.[0]
      : this.Munselect?.IdMunicipio;

    if (!municipalityId) {
      return;
    }

    // Esperar a que el mat-menu pinte el listado antes de hacer scroll
    timer(100)
      .pipe(takeUntilDestroyed(this.$destroyRef))
      .subscribe(() => {
        const selectedItem = document.getElementById(`municipio-${municipalityId}`);
        selectedItem?.scrollIntoView({ block: 'center', inline: 'nearest' });
      });
  }

  /**
   * Valida que el usuario haya aceptado los terminos y condiciones
   */
  validateDialogterminosENS() {
    if (this.fse.optenerValor('terminos') !== "true") {
      this.db.getTerminoEnsUsuario().subscribe((res) => {
        const validTerminos = res[0].terminoEns;
        if (!validTerminos) {
          window.history.replaceState({}, '', '/');
          setTimeout(() => {
            this.acercaDe.terminos.fire().then(() => {
            });
          }, 500);
        }
      })
    }
  }

  /**
   * Cierra y abre el menu de listado de municipios, cada vez que se
   * selecciona un nuevo municipio, para que el menu se recargue con el
   * nuevo listado de municipios.
   */
  changeStateMenuTriggerListMunicipalities() {
    if (this.menuTrigger && this.menuTrigger.menuOpen) {
      this.menuTrigger.closeMenu();
      timer(500).pipe( takeUntilDestroyed(this.$destroyRef) ).subscribe( () => this.menuTrigger.openMenu() );
    } 
  }

}


